import React from 'react';
import css from './css.module.less';
import { OriCollapse, Text } from 'src/components/Antd';
import { Icon } from '@/src/tools/icon';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EAction {
  CLOSE = 'CLOSE',
}

const filterKey = 'filterItem';
const FilterCollapse = (props: any) => {
  const { header, children, displayText, onClear, hasData, onClose } = props;

  const [open, setOpen] = React.useState<any>([]);
  //console.log('open', open);
  const isOpen = (open || []).length > 0;

  const handleOnClose = () => {
    //console.log('handleOnClose');
    setOpen(false);
  };

  React.useEffect(() => {
    window.addEventListener(EAction.CLOSE, handleOnClose);
    return () => {
      window.removeEventListener(EAction.CLOSE, handleOnClose);
    };
  }, []);

  useAfterDidMountEffect(() => {
    if (!isOpen) {
      if (onClose) {
        setTimeout(() => {
          onClose();
        }, 1);
      }
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <OriCollapse
        activeKey={open}
        onChange={setOpen}
        ghost
        className={css.collapseContainer}>
        <OriCollapse.Panel
          forceRender
          header={
            <Header
              title={header}
              open={isOpen}
              hasData={hasData}
              onClear={onClear}
            />
          }
          //className={``}
          key={filterKey}
          showArrow={false}>
          {children}
        </OriCollapse.Panel>
      </OriCollapse>
      {!isOpen && (
        <div className={`${css.explainContainer}`}>
          <NoWrapContainer>
            <GlobalTooltip title={displayText}>{displayText}</GlobalTooltip>
          </NoWrapContainer>
        </div>
      )}
    </React.Fragment>
  );
};
export default FilterCollapse;
const Header = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { title, open, hasData, onClear } = props;
  return (
    <React.Fragment>
      <div className={css.headerContainer}>
        <Icon
          className={css.headerIcon}
          style={
            open
              ? {
                  transform: 'rotate(90deg)',
                }
              : {}
          }
          type='iconright'
        />
        <Text className={css.title}>{title}</Text>
        {hasData && onClear && (
          <div
            className={css.clear}
            onClick={(e) => {
              e.stopPropagation();

              onClear();
            }}>
            {getI18n('general.commonStoreProductsWithTable.clear')}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
